import { RemoveButton } from "../shared/buttons/remove-button";
import { cn, MimeTypes } from "../utls/utils";
import { Thumbnail } from "./thumbnail";

interface ImagePreviewProps {
  src: string;
  onRemove?: () => void;
  size?: "small" | "large";
  fileType?: MimeTypes;
  fileName?: string;
  isActive?: boolean;
  onClick?: () => void;
  allImages?: Array<{ url: string; fileName?: string; fileType?: MimeTypes }>;
  currentIndex?: number;
}

export function ImagePreview({
  src,
  onRemove,
  size = "small",
  fileType,
  fileName,
  isActive = false,
  onClick,
  allImages = [],
  currentIndex = 0,
}: ImagePreviewProps) {
  return (
    <div
      data-testid="image-preview"
      className={cn(
        "relative w-fit shrink-0 transition-all",
        isActive && "transform scale-[1.03]",
        onClick && "cursor-pointer"
      )}
      onClick={onClick}
      tabIndex={onClick ? 0 : undefined}
      role={onClick ? "button" : undefined}
      aria-pressed={onClick && isActive ? true : undefined}
    >
      <Thumbnail
        src={src}
        size={size}
        fileType={fileType}
        fileName={fileName}
        allImages={allImages}
        currentIndex={currentIndex}
      />
      {onRemove && <RemoveButton onClick={onRemove} />}
    </div>
  );
}
